import { render, staticRenderFns } from "./OverlayPanel.vue?vue&type=template&id=674b739d"
import script from "./OverlayPanel.vue?vue&type=script&lang=js"
export * from "./OverlayPanel.vue?vue&type=script&lang=js"
import style0 from "./OverlayPanel.vue?vue&type=style&index=0&id=674b739d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports